import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../../../_services/api/settings.service';

@Component({
  selector: 'app-recent-events-detail',
  templateUrl: './recent-events-detail.component.html',
  styleUrls: ['./recent-events-detail.component.scss']
})
export class RecentEventsDetailComponent implements OnInit {

  log: any = {}
  constructor(
    private router:Router,
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void {
    this.getLogs();
  }

  getLogs(){
    const id =     this.route.snapshot.params['logId'];

    this.settingsService.getLogById(id).subscribe((res)=>{
      this.log = res.data;
    })
  }

  onBack(): void {
    this.router.navigate(['./..']);
  }

  empty(obj): boolean{
    return Object.keys(obj).length == 0;
  }
}
